import { useLocation } from 'react-router-dom';

import { Can } from '@/permissions/Can';
import { PERMISSIONS } from '@/permissions/permissions.catalog';
import { MAINTAIN_ROOT } from '@pages/Equipment/equipmentRoutes';

import EquipmentAIChat from './EquipmentAIChat';

const MaintainAIChatMount = () => {
  const { pathname } = useLocation();

  if (pathname !== MAINTAIN_ROOT && !pathname.startsWith(MAINTAIN_ROOT + '/')) {
    return null;
  }

  return (
    <Can permission={PERMISSIONS.vessel.Equipment}>
      <EquipmentAIChat />
    </Can>
  );
};

export default MaintainAIChatMount;
